import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import apiClient from '../utils/apiClient';

const SuperAdminPromptInjectionLogs = () => {
  const { t } = useTranslation();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [deleting, setDeleting] = useState(false);

  const fetchLogs = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiClient.get('/api/superadmin/prompt-injection-logs');
      setLogs(res.data.logs || []);
    } catch (err) {
      setError('Erreur lors du chargement des logs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const handleDeleteLog = async (logId) => {
    if (!window.confirm('Supprimer cette entrée du journal ?')) return;
    setDeleting(true);
    try {
      await apiClient.delete(`/api/superadmin/prompt-injection-logs/${logId}`);
      setLogs((prev) => prev.filter((log) => log._id !== logId));
    } catch (e) {
      alert('Erreur lors de la suppression');
    } finally {
      setDeleting(false);
    }
  };

  const handleDeleteAll = async () => {
    if (!window.confirm('Supprimer TOUTES les entrées du journal ?')) return;
    setDeleting(true);
    try {
      await apiClient.delete('/api/superadmin/prompt-injection-logs');
      setLogs([]);
    } catch (e) {
      alert('Erreur lors de la suppression globale');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="superadmin-prompt-logs-panel">
      <h2>🛡️ Tentatives de Prompt Injection</h2>
      {loading && <p>{t('superAdminPromptInjectionLogs.loading')}</p>}
      {error && <p style={{color:'red'}}>{error}</p>}
      {!loading && logs.length === 0 && <p>{t('superAdminPromptInjectionLogs.noAttempts')}</p>}
      {!loading && logs.length > 0 && (
        <>
          <button
            onClick={handleDeleteAll}
            disabled={deleting || logs.length === 0}
            style={{ marginBottom: 16, background: '#dc2626', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer' }}
          >
            Supprimer tout le journal
          </button>
          <table className="prompt-logs-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th>Date</th>
                <th>User</th>
                <th>Pattern</th>
                <th>Prompt (extrait)</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, idx) => (
                <tr key={log._id || idx}>
                  <td>{log.date || new Date(log.timestamp || log.createdAt).toLocaleString()}</td>
                  <td>{log.userId || 'inconnu'}</td>
                  <td>{log.pattern || '-'}</td>
                  <td style={{maxWidth:300,overflow:'hidden',textOverflow:'ellipsis', fontSize:13}}>{log.input || log.prompt}</td>
                  <td>
                    <button
                      onClick={() => handleDeleteLog(log._id)}
                      disabled={deleting}
                      style={{ background: '#ef4444', color: 'white', border: 'none', padding: '4px 10px', borderRadius: 4, cursor: 'pointer' }}
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default SuperAdminPromptInjectionLogs;
